import { render } from "./EditInterviewAttachment.vue?vue&type=template&id=734f30e6"
import script from "./EditInterviewAttachment.vue?vue&type=script&lang=js"
export * from "./EditInterviewAttachment.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__